/**
 * @module estrutura/label/utils
 */

import {
	Estrutura,
	Dispositivo
} from '../models';

/**
 * Given the estrutura and dispositivo info, returns the resulting label
 *
 * @param {Estrutura} estrutura information about the estrutura
 * @param {Dispositivo} dispositivo information about the dispositivo
 * @returns {string} resulting label
 */
export function getEstruturaLabelStr( estrutura, dispositivo ) {
	let result = '';

	if ( dispositivo != null ) {
		result = dispositivo.prefixo || '';
		if ( dispositivo.numeracao != null ) {
			if ( estrutura.numero != null ) {
				switch ( dispositivo.numeracao ) {
					case 'R':
						result += romanize( estrutura.numero );
						break;
					case 'L':
						result += characterize( estrutura.numero );
						break;
					case 'N':
						result += estrutura.numero || '';
						break;
				}

				if ( estrutura.numero <= dispositivo.condicao ) {
					result += dispositivo.sufixo || '';
					if ( estrutura.complementar ) {
						result += '-' + estrutura.letra;
					}
				} else {
					if ( estrutura.complementar ) {
						result += '-' + estrutura.letra;
					}
					result += dispositivo.sufixoCondicao || '';
				}
			}

			result = result.trim() + ' ';
		}
	}

	const textarea = document.createElement( 'textarea' );
	textarea.innerHTML = result || ' ';
	return textarea.textContent;
}

function characterize( num ) {
	if ( !+num ) {
		return '';
	}

	const dicSize = 26;
	let val = +num - 1;
	let character = '';
	while ( val >= 0 ) {
		character += String.fromCharCode( 97 + ( val % dicSize ) );
		val -= dicSize;
	}
	return character;
}

function romanize( num ) {
	if ( !+num ) {
		return '';
	}
	const key = [
		'', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM',
		'', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC',
		'', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'
	];
	let digits = String( +num ).split( '' );
	let roman = '';
	let i = 3;
	while ( i-- ) {
		roman = ( key[ +digits.pop() + ( i * 10 ) ] || '' ) + roman;
	}
	return Array( +digits.join( '' ) + 1 ).join( 'M' ) + roman;
}
